import ArrowLeftIcon from '~/components/atoms/Icons/ArrowLeftIcon';
import XIcon from '~/components/atoms/Icons/XIcon';

import { useClosePopup } from '~/hooks/useClosePopup';

import styles from './MenuViewHeader.module.scss';

type TMenuViewHeaderProps = {
  title: string;
  onClose?: (() => void) | null;
  onBack?: () => void;
};

export function MenuViewHeader({
  title,
  onBack,
  onClose,
}: TMenuViewHeaderProps): JSX.Element {
  const closePopup = useClosePopup();

  return (
    <header className={styles.container}>
      {onBack && (
        <ArrowLeftIcon
          onClick={onBack}
          className={styles.backIcon}
          background={false}
        />
      )}
      <h2 className={styles.title}>{title}</h2>
      {onClose !== null && (
        <XIcon
          onClick={onClose || closePopup}
          background={false}
          className={styles.closeIcon}
        />
      )}
    </header>
  );
}
